import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import './InviteRequiredPage.css';

const InviteRequiredPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="invite-required-page">
            <div className="invite-required-container">
                <div className="invite-required-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="5" width="18" height="14" rx="2" />
                        <polyline points="3 7 12 13 21 7" />
                    </svg>
                </div>

                <h1>{t('inviteRequired.title')}</h1>
                <p className="invite-required-description">
                    {t('inviteRequired.description')}
                </p>

                <a
                    href="mailto:nicole@hofsync.de?subject=HofSync%20Invite%20Request"
                    className="invite-required-cta"
                >
                    {t('inviteRequired.requestInvite')}
                </a>

                <p className="invite-required-helper">
                    {t('inviteRequired.contactHelper')}
                </p>

                <button
                    className="invite-required-secondary"
                    onClick={() => navigate('/login')}
                >
                    {t('inviteRequired.alreadyHave')}
                </button>
            </div>
        </div>
    );
};

export default InviteRequiredPage;
